<template>
  <v-tooltip bottom max-width="420" content-class="billing-control-help">
    <template #activator="{ on, attrs }">
      <v-icon x-small :color="dark ? 'white' : 'grey'" class="billing-control-help-icon" v-bind="attrs" v-on="on" @click.stop>mdi-help-circle-outline</v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
/** Le petit « ? » qui explique un chiffre du pilotage financier : ce qu'il compte, et ce qu'il ne compte pas. */
export default {
  name: 'HelpTip',

  props: {
    text: { type: String, required: true },
    /** Sur un fond coloré (bouton plein) : le « ? » en blanc. */
    dark: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.billing-control-help-icon {
  cursor: help;
  vertical-align: baseline;
  margin-left: 2px;
}
</style>

<style lang="scss">
// Dans un en-tête triable, la flèche de tri est posée en absolu dans la marge droite et mord sur la fin du
// libellé : on lui laisse sa place pour que le « ? » reste lisible.
.v-data-table-header th.sortable .billing-control-help-icon {
  margin-right: 14px;
}

.billing-control-help.v-tooltip__content {
  background: white !important;
  color: #374151 !important;
  border: 1px solid #e5e7eb;
  border-left: 3px solid #9ca3af;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 10px 14px;
  font-size: 12.5px;
  line-height: 1.5;
  text-transform: none;
  letter-spacing: normal;
  font-weight: normal;
  opacity: 1 !important;
}
</style>
